import React, { Component } from 'react';
import { RegistrationInfo, RegistrationResponse } from './Helper/DataType';
import { UTCDateTimeNow, EventDateTime } from './Helper/Common';
import { Label, DefaultButton, Link, TextField } from '@fluentui/react';
import { EventInfo } from './EventInfo';
import * as msg from './Helper/Const';
import '../custom.css'

export class DeclineForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            guestUID: props.match.params.id,
            email: '',
            eventTitle: '',
            eventDescription: '',
            eventInfo: '',
            eventDateTime: '',
            gmt: '',
            submit: false,
            comments: '',
            loading: true
        };
    }

    componentDidMount() {
        this.getEventInfo();
    }

    componentDidUpdate() {
        if (document.getElementById("description") !== null) {
            document.getElementById("description").innerHTML = this.state.eventDescription;
        }
    }

    onNotYouLinkClicked = () => {
        this.setState({ responseMessage: msg.NotYou });
        this.setState({ submit: true });
    }

    onSubmitClicked = () => {
        let response = RegistrationResponse();
        response.GuestUID = this.state.guestUID;
        response.Response = 'Decline';
        response.ResponsedDate = UTCDateTimeNow();
        response.EventID = '0';

        if (0 < this.state.comments.length) {
            let regInfo = RegistrationInfo();
            regInfo.DeclineComment = this.state.comments;
            var regInfoText = JSON.stringify(regInfo);
            response.RegistrationInfo = regInfoText;
        }

        var registrationResponse = JSON.stringify(response);
        this.registerEvent(registrationResponse);
    }

    /* Get email given id
     */
    async getEventInfo() {
        const configResponse = await fetch('unsubscribe/getConfigSettings');
        if (configResponse.ok) {
            const systemMaintenance = await configResponse.text();
            if (systemMaintenance === "true") {
                this.props.history.push('/maintenence');
                return;
            }
        }

        const response = await fetch(`registration/getEvent/${msg.ZeroGuid}/${this.state.guestUID}`);
        if (response.ok) {
            const eventInfo = await response.json();
            const eventDate = EventDateTime(eventInfo.StartDateTime, eventInfo.EndDateTime, eventInfo.TimeZone);

            // event expired
            if (eventInfo.EventStatus === 'Expired') {
                this.props.history.push('/regexp');
                return;
            }

            // event closed
            if (eventInfo.EventStatus === 'Closed') {
                this.setState({
                    responseMessage: msg.EventClosedMessage,
                    submit: true
                });
            }

            this.setState({
                email: eventInfo.Email,
                eventTitle: eventInfo.Title,
                eventDescription: eventInfo.Description,
                eventInfo: eventInfo,
                eventDateTime: eventDate,
                loading: false
            });
        }
    }

    /* Save registration info as not Attend in DB
     */
    async registerEvent(registrationResponse) {
        const regResponse = await fetch('registration',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: registrationResponse
            });

        if (regResponse.ok) {
            const message = await regResponse.json();
            if (message === 'Already declined') {
                this.setState({ responseMessage: msg.AlreadyDeclined });
            } else {
                this.setState({ responseMessage: msg.Declined });
            }

            this.setState({ submit: true });
        }        
    }

    render() {
        return (
            <div> {this.state.loading ? <div></div> : 
            <div className="gridContainer">
                <div className="formColumnLeft">
                    <EventInfo eventInfo={this.state.eventInfo}
                        eventDateTime={this.state.eventDateTime}
                        gmt={this.state.gmt} />
                </div>

                <div className="formColumnRight">
                    <Label className="title">{this.state.eventTitle}</Label>
                    <br />
                    <div id="description" className="labelInfo" ></div>
                    <br />
                    {this.state.submit ?
                        <div><Label className="subtitle">
                            {this.state.responseMessage}
                        </Label></div>
                        :
                        <div>
                            <Label className="subtitle">Sorry you can't make it.</Label><br/>
                            <Label className="labelInfo">Before you submit declining, is this your email?</Label>
                            <div class="flex-container">
                                <div class="flex-child" ><Label><b>{this.state.email}</b></Label></div>
                                <Link className="linklInfo" onClick={this.onNotYouLinkClicked}>Not you?</Link>
                            </div><br />
                            <TextField label="Comments" maxLength='200' multiline resizable={false} onChange={(event, newValue) => this.setState({ comments: newValue })}></TextField>
                            <br /><br />
                            <DefaultButton text="Decline" onClick={this.onSubmitClicked} />
                        </div>
                    }
                </div>
            </div>
            }</div>
        );
    }
}